import { OPERATION_ERROR, SHOW_PROGRESS } from "../../../constants/action_types";

export const operationErrored = error => {
    console.log(error);
    return {
        type: OPERATION_ERROR,
        error: error,
        errorHandled: false
    }
};

export const showProgress = show => {
    return {
        type: SHOW_PROGRESS,
        show: show
    }
};